export const api_uri = process.env.REACT_APP_API_URL || "";

//--------------------------------- 관리자 ---------------------------------
export const enum_api_uri = {
    api_uri: `${api_uri}`,

    //공통 ------------------------------------------
    common_get_customer: `${api_uri}/v1/common/customer`,
    common_get_target_customer: `${api_uri}/v1/common/customer/:customer_idx`,
    common_get_delivery: `${api_uri}/v1/common/delivery`,
    common_get_sender: `${api_uri}/v1/common/sender`,
    common_get_word: `${api_uri}/v1/common/word`,
    common_get_memo: `${api_uri}/v1/common/delivery/memo`,
    common_get_event: `${api_uri}/v1/common/event`,
    common_get_cancel: `${api_uri}/v1/common/cancel`,
    common_get_pay_method: `${api_uri}/v1/common/method/:payment_category`,
    common_get_word_category: `${api_uri}/v1/common/word/category`,

    // 주문판매 ------------------------------------------
    get_order: `${api_uri}/v1/console/order`,
    post_order: `${api_uri}/v1/console/order`,
    delete_order: `${api_uri}/v1/console/order`,
    get_order_info: `${api_uri}/v1/console/order`,
    put_order_info: `${api_uri}/v1/console/order`,
    get_order_status: `${api_uri}/v1/console/order/status`,
    put_order_branch_delete: `${api_uri}/v1/console/order/branch-delete`, // 지점 삭제 / 해제
    get_order_history: `${api_uri}/v1/console/order/:order_idx/status`,
    post_order_photo_check: `${api_uri}/v1/console/order/:order_idx/photo-check`,
    daily_memo: `${api_uri}/v1/console/order/daily-memo`, // 일자별 공유 메모 (조회 GET / 저장 PUT)
    daily_memo_dates: `${api_uri}/v1/console/order/daily-memo/dates`, // 메모 있는 날짜 목록 (달력 점 표시)
    get_order_chat: `${api_uri}/v1/console/order/alrimtalk/:order_idx`,
    get_order_product: `${api_uri}/v1/console/order/product`,
    get_order_customer: `${api_uri}/v1/console/order/customer`,
    get_order_branch: `${api_uri}/v1/console/order/branch`,
    get_order_branch_option: `${api_uri}/v1/console/order/branch/option`,
    put_order_branch: `${api_uri}/v1/console/order/:order_idx/branch`,
    get_order_count: `${api_uri}/v1/console/order/count`,
    post_order_copy: `${api_uri}/v1/console/order/copy`,
    put_order_cancel: `${api_uri}/v1/console/order/cancel`,
    put_order_receipt: `${api_uri}/v1/console/order/receipt`,
    post_order_excel_download: `${api_uri}/v1/console/order/excel/download`,
    post_order_excel_receipt: `${api_uri}/v1/console/order/excel/download/receipt`,
    post_order_excel_form: `${api_uri}/v1/console/order/excel/form`,
    post_excel: `${api_uri}/v1/console/order/excel/upload`,
    get_order_manager: `${api_uri}/v1/console/order/customer/:customer_idx/manager`,
    get_branch_product: `${api_uri}/v1/console/order/branch/product`,
    post_branch_product: `${api_uri}/v1/console/order/branch/product`,
    get_branch_product_detail: `${api_uri}/v1/console/order/branch/product/:branch_product_idx`,
    put_branch_product_detail: `${api_uri}/v1/console/order/branch/product/:branch_product_idx`,
    get_order_date_count: `${api_uri}/v1/console/order/date-count`,
    put_order_receipt_idx: `${api_uri}/v1/console/order/receipt`,
    get_order_stats: `${api_uri}/v1/console/order/stats`,

    // 고객매출 ------------------------------------------
    get_sales: `${api_uri}/v1/console/sales`,
    get_sales_count: `${api_uri}/v1/console/sales/count`,
    get_sales_customer_count: `${api_uri}/v1/console/sales/:customer_idx/count`,
    get_sales_info: `${api_uri}/v1/console/sales/:customer_idx/info`,
    get_sales_payment: `${api_uri}/v1/console/sales/:customer_idx/payment`,
    put_sales_memo: `${api_uri}/v1/console/sales/:customer_idx/payment/memo/:payment_history_idx`,
    post_sales: `${api_uri}/v1/console/sales/:customer_idx/payment`,
    get_sales_delivery_date: `${api_uri}/v1/console/sales/:customer_idx/date`,

    // 타지점정산 ------------------------------------------
    get_settlements: `${api_uri}/v1/console/settlements`,
    get_settlements_count: `${api_uri}/v1/console/settlements/count`,
    get_settlements_customer_count: `${api_uri}/v1/console/settlements/:customer_idx/count`,
    get_settlements_info: `${api_uri}/v1/console/settlements/:customer_idx/info`,
    get_settlements_payment: `${api_uri}/v1/console/settlements/:customer_idx/payment`,
    put_settlements_memo: `${api_uri}/v1/console/settlements/:customer_idx/payment/memo/:payment_history_idx`,
    post_settlements: `${api_uri}/v1/console/settlements/:customer_idx/payment`,
    post_settlements_excel_receipt: `${api_uri}/v1/console/settlements/excel/download`,
    get_settlements_delivery_date: `${api_uri}/v1/console/settlements/:customer_idx/date`,

    // 회원 ------------------------------------------
    refresh: `${api_uri}/v1/auth/refresh`,
    login: `${api_uri}/v1/auth/console/login`,
    get_alert_list: `${api_uri}/v1/console/alert`,
    get_alert_read: `${api_uri}/v1/console/alert/read`,
    put_alert_read: `${api_uri}/v1/console/alert/:alert_idx/read`,
    get_member: `${api_uri}/v1/console/member`,
    put_member: `${api_uri}/v1/console/member`,
    post_member: `${api_uri}/v1/console/member`,
    get_member_info: `${api_uri}/v1/console/member`,
    delete_member: `${api_uri}/v1/console/member`,

    // 관리>고객 ------------------------------------------
    post_customer: `${api_uri}/v1/console/management/customer`,
    get_customer: `${api_uri}/v1/console/management/customer`,
    get_customer_excel: `${api_uri}/v1/console/management/customerExcel`,
    put_customer: `${api_uri}/v1/console/management/customer`,
    delete_customer: `${api_uri}/v1/console/management/customer`,
    put_customer_status: `${api_uri}/v1/console/management/customer/:customer_id/status`,
    put_customer_option: `${api_uri}/v1/console/management/customer/:customer_idx/option/:customer_option_idx`,
    post_customer_memo: `${api_uri}/v1/console/management/customer/:customer_idx/memo`,
    get_customer_memo: `${api_uri}/v1/console/management/customer/:customer_idx/memo`,
    put_customer_memo: `${api_uri}/v1/console/management/customer/:customer_idx/memo/:customer_memo_idx`,
    delete_customer_memo: `${api_uri}/v1/console/management/customer/:customer_idx/memo/:customer_memo_idx`,
    post_customer_manager: `${api_uri}/v1/console/management/customer/:customer_idx/manager`,
    get_customer_manager: `${api_uri}/v1/console/management/customer/:customer_idx/manager`,
    delete_customer_manager: `${api_uri}/v1/console/management/customer/:customer_idx/manager/:customer_manager_idx`,
    put_customer_manager: `${api_uri}/v1/console/management/customer/:customer_idx/manager/:customer_manager_idx`,
    post_customer_sender: `${api_uri}/v1/console/management/customer/:customer_idx/sender`,
    get_customer_sender: `${api_uri}/v1/console/management/customer/:customer_idx/sender`,
    delete_customer_sender: `${api_uri}/v1/console/management/customer/:customer_idx/sender/:sender_idx`,
    put_customer_sender: `${api_uri}/v1/console/management/customer/:customer_idx/sender/:sender_idx`,
    put_customer_sender_status: `${api_uri}/v1/console/management/customer/:customer_idx/sender/:sender_idx/status`,
    get_customer_category: `${api_uri}/v1/console/management/customer/:customer_idx/category`,
    put_customer_category: `${api_uri}/v1/console/management/customer/:customer_idx/category`,
    get_customer_event_content: `${api_uri}/v1/console/management/customer/:customer_idx/event-content`,
    put_customer_event_content: `${api_uri}/v1/console/management/customer/:customer_idx/event-content`,

    // 관리>경조사어 ------------------------------------------
    get_word: `${api_uri}/v1/console/management/word`,
    post_word: `${api_uri}/v1/console/management/word`,
    put_word: `${api_uri}/v1/console/management/word`,
    delete_word: `${api_uri}/v1/console/management/word`,
    put_word_status: `${api_uri}/v1/console/management/word/:word_idx/status`,
    get_word_info: `${api_uri}/v1/console/management/word`,
    put_word_category: `${api_uri}/v1/console/management/word/category`,

    //관리>상품 ------------------------------------------
    get_product: `${api_uri}/v1/console/management/product`,
    get_product_info: `${api_uri}/v1/console/management/product`,
    post_product: `${api_uri}/v1/console/management/product`,
    put_product: `${api_uri}/v1/console/management/product`,
    delete_product: `${api_uri}/v1/console/management/product`,
    put_product_restore: `${api_uri}/v1/console/management/product/restore`,
    put_product_status: `${api_uri}/v1/console/management/product/:product_idx/status`,
    get_product_code: `${api_uri}/v1/console/management/product/code`,
    get_product_order_count: `${api_uri}/v1/console/management/product/order-count`,
    get_product_history: `${api_uri}/v1/console/management/product/:product_idx/history`,
    get_product_category: `${api_uri}/v1/console/management/product/category`,
    put_product_category: `${api_uri}/v1/console/management/product/category`,
    post_product_category: `${api_uri}/v1/console/management/product/category`,
    delete_product_category: `${api_uri}/v1/console/management/product/category`,

    //--------------------------------- 사용자 ---------------------------------
    user: {
        login: `${api_uri}/v1/auth/login`,
        signup: `${api_uri}/v1/auth/signup`,
        get_customer: `${api_uri}/v1/user/info`,
        put_customer: `${api_uri}/v1/user/info/customer`,
        put_password: `${api_uri}/v1/user/info/password`,
        get_category: `${api_uri}/v1/user/product/category/:customer_idx`,
        get_product: `${api_uri}/v1/user/product/list/:customer_idx`,
        get_product_info: `${api_uri}/v1/user/product/info/:product_idx`,
        post_send_password: `${api_uri}/v1/auth/reset-password/send`,
        put_reset_password: `${api_uri}/v1/auth/reset-password/reset`,
        post_order: `${api_uri}/v1/user/order`,
        get_order_info: `${api_uri}/v1/user/order/:order_idx`,
        put_order_info: `${api_uri}/v1/user/order/:order_idx`,
        put_order_cancel: `${api_uri}/v1/user/order/cancel`,
        get_order: `${api_uri}/v1/user/order`,
    },
};
